<template>
  <svg aria-hidden="true" focusable="false" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="m30 16-4.788 4.788c-.447.447-1.212.13-1.212-.502v-2.786h-6.5v6.5h2.786c.633 0 .949.765.502 1.212l-4.788 4.788-4.788-4.788c-.447-.447-.13-1.212.502-1.212h2.786v-6.5h-6.5v2.786c0 .633-.765.949-1.212.502l-4.788-4.788 4.788-4.788c.447-.447 1.212-.13 1.212.502v2.786h6.5v-6.5h-2.786c-.633 0-.949-.765-.502-1.212l4.788-4.788 4.788 4.788c.447.447.13 1.212-.502 1.212h-2.786v6.5h6.5v-2.786c0-.633.765-.949 1.212-.502z"
    />
  </svg>
</template>
<script>
export default {
  name: "M4AllDirectionsSvg"
};
</script>
